import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import cx from 'classnames';
import FormCheckbox from '../Forms/FormCheckbox';
import FormError from '../Forms/FormError';
import Button from '../Button';
import styles from './ConnectWithCollegeModal.css';
import { updateConnectionsAction } from '../../redux/colleges';
import appStyles from '../../styles/app.css';

const ConnectWithCollegeForm = ({
    programs,
    alreadyConnected,
    handleSubmit,
    submitting,
    pristine,
    error,
    updateLabel,
    createLabel,
    invalid,
}) => (<form onSubmit={handleSubmit}>
    <FormError error={error} />
    <div className={cx(styles.checkboxes, appStyles.clearfix)}>
        {programs.map(program => (
            <Field
                key={program.collegeProgramID_PK}
                name={program.collegeProgramID_PK.toString()}
                label={program.name}
                component={FormCheckbox}
                className={styles.checkbox}
                iconClassName={styles.checboxIcon}
            />
        ))}
    </div>
    <div className={styles.action}>
        <Button
            type="submit"
            loading={submitting}
            disabled={pristine || invalid}
        >
            {alreadyConnected ? updateLabel : createLabel}
        </Button>
    </div>
</form>);

ConnectWithCollegeForm.propTypes = {
    programs: PropTypes.array,
    handleSubmit: PropTypes.func,
    alreadyConnected: PropTypes.bool,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    error: PropTypes.any,
    updateLabel: PropTypes.string,
    createLabel: PropTypes.string,
    invalid: PropTypes.bool,
};

ConnectWithCollegeForm.defaultProps = {
    updateLabel: 'Save Changes',
    createLabel: 'Save Connection',
};

export default compose(
    connect(({ colleges }, { college }) => {
        const collegeId = get(college, 'collegeID_PK', null);
        const connections = get(colleges.connections, `${collegeId}.programs`, []);
        const programs = get(college, 'programs', []);
        const initialValues = {};
        const alreadyConnected = connections && connections.length > 0;
        programs.forEach((p) => {
            const id = p.collegeProgramID_PK;
            initialValues[id] = connections.indexOf(id) !== -1;
        });
        return {
            open: !!college,
            programs,
            initialValues,
            alreadyConnected,
            collegeId,
        };
    }, {
        updateConnections: updateConnectionsAction,
    }),
    withHandlers({
        onSubmit: ({ updateConnections, collegeId }) => body => (
            new Promise((resolve, reject) => {
                updateConnections({
                    collegeId,
                    connections: Object.keys(body)
                        .filter(programId => body[programId])
                        .map(Number),
                    resolve,
                    reject,
                });
            })
        ),
    }),
    reduxForm({
        form: 'connect-with-college-form',
        enableReinitialize: true,
    }),
)(ConnectWithCollegeForm);



// WEBPACK FOOTER //
// ./src/client/Components/ConnectWithCollegeModal/ConnectWithCollegeForm.js